import React from 'react';
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { toast } from 'react-toastify';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

import DashboardMetricCard from '../../../components/common/DashboardMetricCard';
import StatusBadge from '../../../components/common/StatusBadge';
import ComponentCard from '../../../components/ComponentCard';
import BreadCrumbs from '../../../layouts/breadcrumbs/BreadCrumbs';
import ActionButton from '../../../components/common/ActionButton';
import AppButton from '../../../components/common/AppButton';
import ImagePreviewModal from './category-management/ImagePreviewModal';
import {
  parseIncludedServices,
  joinIncludedServices,
} from './category-management/includedServices';
import DataTable from '../../../components/common/DataTable';
import api from '../../../constants/api';
import { showSwal } from '../../../constants/swalConfig';

const emptyServiceForm = {
  categoryId: '',
  name: '',
  salonPrice: '',
  fourWheelPrice: '',
  duration: '',
  description: '',
  includedServices: [],
  active: true,
};
const emptyCategoryForm = {
  name: '',
  active: true,
};
const MAX_IMAGE_SIZE = 500 * 1024;
export default function CategoryManagement() {
  const [categories, setCategories] = React.useState([]);
  const [allCategories, setAllCategories] = React.useState([]);
// const [loadingCategories, setLoadingCategories] = React.useState(false);
  const [categoryModal, setCategoryModal] = React.useState(false);
  const [categoryForm, setCategoryForm] = React.useState(emptyCategoryForm);
const [categoryImage, setCategoryImage] = React.useState(null);
const [editCategoryImage, setEditCategoryImage] = React.useState(null);
  const [previewImage, setPreviewImage] = React.useState('');
const [serviceImage, setServiceImage] = React.useState(null);
const serviceImageInputRef = React.useRef(null);

  const [manageCategoryModal, setManageCategoryModal] = React.useState(false);
  const [editingCategory, setEditingCategory] = React.useState(null);
  const [editCategoryName, setEditCategoryName] = React.useState('');
  const [editCategoryActive, setEditCategoryActive] = React.useState(true);
  const [serviceForm, setServiceForm] = React.useState(emptyServiceForm);
  const [errors, setErrors] = React.useState({});
  const [editingService, setEditingService] = React.useState(null);
  const [validation, setValidation] = React.useState('');
  const totalSubcategories = categories.reduce(
    (total, category) => total + category.subcategories.length,
    0,
  );
 const getServicesByCategory = React.useCallback(async (categoryId) => {

  try {
    const response = await api.get('/service/getServices', {
      params: {
        serviceTypeId: categoryId,
        all: true,
      },
    });

    const services = Array.isArray(response?.data?.data)
      ? response.data.data
      : [];

    setCategories((previous) =>
      previous.map((category) =>
        category.id === categoryId
          ? {
              ...category,
              subcategories: services.map((service) => ({
  id: service.sp_id,
  name: service.sp_name_en || '',
  image: service.sp_img || '',
  price: service.sp_four_price_en ?? '',
  salonPrice: service.sp_salon_price_en ?? '',
  duration: service.sp_estimated_time ?? '',
  description: service.sp_desp_en || '',
  includedServices: service.sp_included_serv_en || '',
  distance: '',
  active: Number(service.sp_isactive) === 1,
  rawData: service,
})),
            }
          : category,
      ),
    );
  } catch (error) {
    console.error(
      `Failed to fetch services for category ${categoryId}:`,
      error,
    );

    toast.error('Unable to load services for this category.');
    }
}, []);

const getServiceTypes = React.useCallback(async () => {
  try {
    const response = await api.get('/service/getServiceTypes');

    const serviceTypes = Array.isArray(response?.data?.data)
      ? response.data.data
      : [];

    const mappedCategories = serviceTypes
      .map((category) => ({
        id: category.service_category_id,
        name: category.service_category_name_en || '',
        active: Number(category.service_category_isactive) === 1,
        rawData: category,
        subcategories: [],
      }))
      .filter((category) => category.active);

        setCategories(mappedCategories);

        await Promise.all(
          mappedCategories.map((category) =>
            getServicesByCategory(category.id),
          ),
        );
      } catch (error) {
        console.error('Failed to fetch active service types:', error);
        toast.error('Unable to load categories.');
        setCategories([]);
      }
    }, [getServicesByCategory]);


    React.useEffect(() => {
      getServiceTypes();
    }, [getServiceTypes]);

      const getAllServiceTypes = React.useCallback(async () => {
        try {
          const response = await api.get('/service/getServiceTypes', {
            params: {
              all: true,
            },
          });

        const serviceTypes = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

    const mappedCategories = await Promise.all(
      serviceTypes.map(async (category) => {
        let subcategoryCount = 0;

        try {
          const serviceResponse = await api.get('/service/getServices', {
            params: {
              serviceTypeId: category.service_category_id,
              all: true,
            },
          });

          const services = Array.isArray(serviceResponse?.data?.data)
            ? serviceResponse.data.data
            : [];

          subcategoryCount = services.length;
        } catch (error) {
          console.error(
            `Failed to fetch services for category ${category.service_category_id}:`,
            error,
          );
        }

       return {
  id: category.service_category_id,
  name: category.service_category_name_en || '',
  image: category.service_category_img || '',
  active: Number(category.service_category_isactive) === 1,
  rawData: category,
  subcategories: [],
  subcategoryCount,
};
      }),
    );

      setAllCategories(mappedCategories);
    } catch (error) {
      console.error('Failed to fetch all service types:', error);
      toast.error('Unable to load all categories.');
      setAllCategories([]);
    }
  }, []);
    const activeSubcategories = categories.reduce(
      (total, category) =>
        total + category.subcategories.filter((item) => item.active).length,
      0,
    );

    const serviceTableData = React.useMemo(
      () =>
        categories.flatMap((category) =>
          category.subcategories.map((service) => ({
            ...service,
            categoryId: category.id,
            categoryName: category.name,
          })),
        ),
      [categories],
    );
    const deleteService = async (categoryId, serviceId) => {
    const result = await showSwal({
  title: 'Are you sure?',
  text: 'Do you want to delete this Service?',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, Delete',
  cancelButtonText: 'Cancel',
  reverseButtons: false,
}, 'delete');

  if (!result.isConfirmed) {
    return;
  }

  try {
    await api.delete(`/service/deleteService/${serviceId}`);

  await showSwal({
  title: 'Deleted!',
  text: 'Service deleted successfully.',
  icon: 'success',
  confirmButtonText: 'OK',
});

    await getServicesByCategory(Number(categoryId));
  } catch (error) {
    console.error('Failed to delete service:', error);

   await showSwal({
  title: 'Error',
  text:
    error?.response?.data?.message ||
    'Unable to delete Service.',
  icon: 'error',
  confirmButtonText: 'OK',
});
  }
};
 const editService = (categoryId, service) => {
  setEditingService(service);

  setServiceForm({
    categoryId: String(categoryId),
    name: service.name,
    salonPrice: service.salonPrice || '',
    fourWheelPrice: service.price || '',
    duration: service.duration || '',
    description: service.description || '',
    includedServices: parseIncludedServices(service.includedServices),
    active: service.active,
  });

  setValidation('');

    window.scrollTo({
      top: 250,
      behavior: 'smooth',
    });
  };
const serviceColumns = [
  {
  key: 'index',
  header: 'S.No',
  width: '6%',
  render: (_, index) => index + 1,
},
{
  key: 'image',
  header: 'Image',
  width: '10%',
  render: (row) => {
    if (!row.image) {
      return (
        <span className="text-muted">
          No Image
        </span>
      );
    }

    const imagePath = row.image.replace(/^\/+/, '');

const imageUrl = row.image.startsWith('http')
  ? row.image
  : imagePath.startsWith('uploads/')
    ? `https://api.fleetnexis.datadove.tech/${imagePath}`
    : `https://api.fleetnexis.datadove.tech/uploads/${imagePath}`;
    return (
      <button
        type="button"
        onClick={() => setPreviewImage(imageUrl)}
        style={{
          border: 'none',
          background: 'transparent',
          padding: 0,
          cursor: 'pointer',
        }}
        aria-label={`Preview ${row.name || 'service'} image`}
      >
        <img
          src={imageUrl}
          alt={row.name || 'Service'}
          style={{
            width: '45px',
            height: '45px',
            objectFit: 'cover',
            borderRadius: '6px',
            border: '1px solid #ddd',
            display: 'block',
          }}
        />
      </button>
    );
  },
},
    {
      key: 'categoryName',
    header: ' Category',
    width: '16%',
  },
  {
    key: 'name',
    header: 'Services',
    width: '20%',
  },
  {
    key: 'salonPrice',
    header: 'Salon Price',
    width: '12%',
   render: (row) => row.salonPrice,
  },
  {
    key: 'price',
    header: 'Four Wheeler Price',
    width: '15%',
    render: (row) => row.price,
  },
  {
    key: 'duration',
    header: 'Duration',
    width: '10%',
    render: (row) => `${row.duration} min`,
  },
  {
    key: 'active',
    header: 'Status',
    width: '10%',
    render: (row) => (
      <StatusBadge
        variant={row.active ? 'success' : 'danger'}
        label={row.active ? 'Active' : 'Inactive'}
      />
    ),
  },
  {
    key: 'actions',
    header: 'Actions',
    width: '11%',
    render: (row) => (
      <div className="d-flex gap-2">
        <ActionButton
          action="edit"
          onClick={() =>
            editService(row.categoryId, row)
          }
        />

        <ActionButton
          action="delete"
          onClick={() =>
            deleteService(row.categoryId, row.id)
          }
        />
      </div>
    ),
  },
];

const resetServiceForm = () => {
  setServiceForm(emptyServiceForm);
  setEditingService(null);
  setServiceImage(null);

  if (serviceImageInputRef.current) {
    serviceImageInputRef.current.value = '';
  }

  setErrors({});
  setValidation('');
};
 const handleServiceChange = (field, value) => {
  setServiceForm((previous) => ({
    ...previous,
    [field]: value,
  }));

  if (validation) {
    setValidation('');
  }
};

const openManageCategories = async () => {
  setEditingCategory(null);
  setEditCategoryName('');
  setEditCategoryActive(true);

  await getAllServiceTypes();

  setManageCategoryModal(true);
};

const handleEditCategory = (category) => {
  setEditingCategory(category);
  setEditCategoryName(category.name || '');
  setEditCategoryActive(Boolean(category.active));

  setTimeout(() => {
    document
      .getElementById('update-main-category-form')
      ?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
  }, 100);
};

const handleCancelEditCategory = () => {
  setEditingCategory(null);
  setEditCategoryName('');
  setEditCategoryActive(true);
  setEditCategoryImage(null);
};

const handleUpdateCategory = async () => {
  const newErrors = {};

  if (!editingCategory) {
    newErrors.editCategoryName = 'Please select a Category.';
  } else if (!editCategoryName.trim()) {
    newErrors.editCategoryName = ' Category name is required.';
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    return;
  }

  // Check whether anything was changed
  if (editingCategory) {
    const hasChanges =
      editCategoryName.trim() !==
        String(editingCategory.name || '').trim() ||
      editCategoryActive !== editingCategory.active ||
      !!editCategoryImage;

    if (!hasChanges) {
      toast.warning(
        'No changes made. Please update at least one field.',
      );
      return;
    }
  }

  try {
    const rawCategory = editingCategory.rawData || {};

    const formData = new FormData();

    formData.append(
      'service_category_name_en',
      editCategoryName.trim(),
    );

    formData.append(
      'service_category_name_ar',
      rawCategory.service_category_name_ar || '',
    );

    formData.append(
      'service_category_isactive',
      editCategoryActive ? '1' : '0',
    );

    formData.append(
      'color',
      rawCategory.color || '',
    );

    if (editCategoryImage) {
      formData.append('image', editCategoryImage);
    }

    await api.put(
      `/service/updateServiceType/${editingCategory.id}`,
      formData,
    );

    toast.success(' Category updated successfully.');

    handleCancelEditCategory();
    setEditCategoryImage(null);

    await getServiceTypes();
    await getAllServiceTypes();
  } catch (error) {
    console.error('Failed to update Category:', error);

    toast.error(
      error?.response?.data?.message ||
        'Unable to update  Category.',
    );
  }
};
const handleDeleteCategory = async (category) => {
  if (!category?.id) {
    toast.error('Invalid Category.');
    return;
  }

const result = await showSwal({
  title: 'Delete Category?',
  text: `Are you sure you want to delete "${category.name}"? This may also affect its subcategories.`,
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, Delete',
  cancelButtonText: 'Cancel',
  reverseButtons: false,
}, 'delete');

if (!result.isConfirmed) {
  return;
}

  try {
    await api.delete(
      `/service/deleteServiceType/${category.id}`,
    );

    toast.success('Category deleted successfully.');

    if (editingCategory?.id === category.id) {
      handleCancelEditCategory();
    }

    await getServiceTypes();
await getAllServiceTypes();
  } catch (error) {
    console.error(
      'Failed to delete Category:',
      error,
    );

    toast.error(
      error?.response?.data?.message ||
        'Unable to delete Category.',
    );
  }
};

const categoryColumns = [
  {
    key: 'index',
    header: 'S.No',
    width: '8%',
    render: (_, index) => index + 1,
  },
  {
    key: 'image',
    header: 'Image',
    width: '12%',
 render: (row) => {
  if (!row.image) {
    return (
      <span className="text-muted">
        No Image
      </span>
    );
  }

  const imagePath = row.image.replace(/^\/+/, '');

  const imageUrl = row.image.startsWith('http')
    ? row.image
    : imagePath.startsWith('uploads/')
      ? `https://api.fleetnexis.datadove.tech/${imagePath}`
      : `https://api.fleetnexis.datadove.tech/uploads/${imagePath}`;

  return (
    <button
      type="button"
      onClick={() => setPreviewImage(imageUrl)}
      style={{
        border: 'none',
        background: 'transparent',
        padding: 0,
        cursor: 'pointer',
      }}
      aria-label={`Preview ${row.name || 'category'} image`}
    >
      <img
        src={imageUrl}
        alt={row.name || 'Category'}
        style={{
          width: '45px',
          height: '45px',
          objectFit: 'cover',
          borderRadius: '6px',
          border: '1px solid #ddd',
          display: 'block',
        }}
      />
    </button>
  );
},
  },
  {
    key: 'name',
    header: 'Category',
    render: (row) => (
      <span className="fw-semibold">{row.name}</span>
    ),
  },
  {
    key: 'subcategoryCount',
    header: 'Services',
    render: (row) => row.subcategoryCount ?? 0,
  },
  {
    key: 'active',
    header: 'Status',
    width: '15%',
    render: (row) => (
      <StatusBadge
        variant={row.active ? 'success' : 'danger'}
        label={row.active ? 'Active' : 'Inactive'}
      />
    ),
  },
  {
    key: 'actions',
    header: 'Actions',
    width: '20%',
    render: (row) => (
      <div className="d-flex align-items-center gap-2">
        <ActionButton
          action="edit"
          onClick={() => handleEditCategory(row)}
        />

        <ActionButton
          action="delete"
          onClick={() => handleDeleteCategory(row)}
        />
      </div>
    ),
  },
];



const saveCategory = async () => {
  const name = categoryForm.name.trim();

  if (!name) {
    setErrors((previous) => ({
      ...previous,
      categoryName: 'Category name is required.',
    }));
    return;
  }

  setErrors((previous) => ({
    ...previous,
    categoryName: '',
  }));

  const alreadyExists = categories.some(
    (category) => category.name.toLowerCase() === name.toLowerCase(),
  );

  if (alreadyExists) {
    setValidation('This Category already exists.');
    return;
  }

  try {
    const formData = new FormData();

    formData.append('service_category_name_en', name);
    formData.append(
      'service_category_isactive',
      categoryForm.active ? '1' : '0',
    );

    // Add image only if user selected one
    if (categoryImage) {
      formData.append('image', categoryImage);
    }

    const response = await api.post(
      '/service/addServiceType',
      formData,
    );

    console.log('Add category response:', response.data);

    toast.success('Category added successfully.');

    setCategoryForm(emptyCategoryForm);
    setCategoryImage(null);
    setCategoryModal(false);
    setValidation('');

    await getServiceTypes();
    await getAllServiceTypes();
  } catch (error) {
    console.error('Failed to add category:', error);

    toast.error(
      error?.response?.data?.message ||
        'Unable to add Category.',
    );
  }
};

const saveService = async () => {
  const newErrors = {};

  if (!serviceForm.categoryId) {
    newErrors.categoryId = 'Category is required.';
  }

  if (!serviceForm.name.trim()) {
    newErrors.name = 'Service name is required.';
  }

  if (!serviceForm.salonPrice) {
    newErrors.salonPrice = 'Salon Price is required.';
  }

  if (!serviceForm.fourWheelPrice) {
    newErrors.fourWheelPrice = 'Four Wheeler Price is required.';
  }

  if (!serviceForm.duration) {
    newErrors.duration = 'Duration is required.';
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    return;
  }
if (editingService) {
  const hasChanges =
    String(serviceForm.categoryId) !==
      String(editingService.categoryId) ||
    serviceForm.name.trim() !==
      String(editingService.name || '').trim() ||
    Number(serviceForm.salonPrice) !==
      Number(editingService.salonPrice || 0) ||
    Number(serviceForm.fourWheelPrice) !==
      Number(editingService.price || 0) ||
    String(serviceForm.duration) !==
      String(editingService.duration || '') ||
    serviceForm.description.trim() !==
      String(editingService.description || '').trim() ||
    joinIncludedServices(serviceForm.includedServices) !==
      joinIncludedServices(
        parseIncludedServices(editingService.includedServices),
      ) ||
    serviceForm.active !== editingService.active ||
    !!serviceImage;

 if (!hasChanges) {
  toast.warning(
    'No changes made. Please update at least one field.',
  );
  return;
}
}
  try {
    const formData = new FormData();

    formData.append(
      'sp_name_en',
      serviceForm.name.trim(),
    );

    formData.append(
      'sp_salon_price_en',
      Number(serviceForm.salonPrice),
    );

    formData.append(
      'sp_four_price_en',
      Number(serviceForm.fourWheelPrice),
    );

    formData.append(
      'sp_cat_id',
      Number(serviceForm.categoryId),
    );

    formData.append(
      'sp_estimated_time',
      String(serviceForm.duration),
    );

    formData.append(
      'sp_isactive',
      serviceForm.active ? '1' : '0',
    );

    // Always sent, so clearing either field on edit clears it in the database.
    formData.append(
      'sp_desp_en',
      serviceForm.description.trim(),
    );

    // addService copies the description into sp_desp_ar and the mobile API
    // falls back to sp_desp_ar when sp_desp_en is empty, so keep them equal or
    // a cleared description would still show in the app.
    formData.append(
      'sp_desp_ar',
      serviceForm.description.trim(),
    );

    formData.append(
      'sp_included_serv_en',
      joinIncludedServices(serviceForm.includedServices),
    );

    // Send image only when selected
    if (serviceImage) {
      formData.append('image', serviceImage);
    }

    // Keep existing image when editing and no new image is selected
    if (
      editingService &&
      !serviceImage &&
      editingService.rawData?.sp_img
    ) {
      formData.append(
        'sp_img',
        editingService.rawData.sp_img,
      );
    }

    if (editingService) {
      await api.put(
        `/service/updateService/${editingService.id}`,
        formData,
      );

      toast.success(
        'Service updated successfully.',
      );
    } else {
      await api.post(
        '/service/addService',
        formData,
      );

      toast.success(
        'Service added successfully.',
      );
    }

    await getServicesByCategory(
      Number(serviceForm.categoryId),
    );

    resetServiceForm();
  } catch (error) {
    console.error('Failed to save service:', error);

    toast.error(
      error?.response?.data?.message ||
        'Unable to save Service.',
    );
  }
};
  return (
    <>
      <BreadCrumbs />

      <div className="category-management-page">
      <Row>
        <Col sm="12">
          <ComponentCard >
            {/* Header */}
          

            {/* Summary */}
                        <Row className="category-summary-row mb-4">
            <Col sm="12" lg="4">
                <DashboardMetricCard
                title="Category"
                value={categories.length}
                icon="bi bi-folder"
                iconColor="#1E60DD"
                iconBackgroundColor="#eaf1ff"
                bgColor="rgb(234, 241, 255)"
                />
            </Col>

            <Col sm="12" lg="4">
                <DashboardMetricCard
                title="Services"
                value={totalSubcategories}
                icon="bi bi-list-check"
                iconColor="#2bb673"
                iconBackgroundColor="#e6f8f0"
                bgColor="rgb(230, 248, 240)"
                />
            </Col>

            <Col sm="12" lg="4">
                <DashboardMetricCard
                title="Active Services"
                value={activeSubcategories}
                icon="bi bi-check-circle"
                iconColor="#f5a623"
                iconBackgroundColor="#fff4e5"
                bgColor="rgb(255, 244, 229)"
                />
            </Col>
            </Row>

          {/* ADD / EDIT SERVICE FORM */}
    <ComponentCard
      title={
        <div className="d-flex justify-content-between align-items-center w-100">
          <span>
            {editingService
              ? 'Edit Service'
              : 'Add Service'}
          </span>

          <div className="d-flex gap-2">
            <AppButton
              label="Add Category"
              onClick={() => {
   setCategoryModal(true);
setCategoryForm(emptyCategoryForm);
setCategoryImage(null);
setErrors({});
setValidation('');
    }}
            />

            <AppButton
              label="Update Category"
              variant="primary"
              outline
              type="button"
              onClick={openManageCategories}
            />
          </div>
        </div>
      }
      className="mb-4"
    >
      <Row>
        {/* Main Category */}
        <Col md="4">
          <FormGroup>
            <Label className="app-text-label">
               Category{' '}
              <small className="text-danger">*</small>
            </Label>

            <Input
      type="select"
      value={serviceForm.categoryId}
      invalid={!!errors.categoryId}
      onChange={async (event) => {
        const categoryId = event.target.value;

        handleServiceChange('categoryId', categoryId);

        setErrors((previous) => ({
          ...previous,
          categoryId: '',
        }));

        if (!categoryId) {
          return;
        }

        await getServicesByCategory(Number(categoryId));
      }}
    >
      {errors.categoryId && (
      <div className="field-error">
        {errors.categoryId}
      </div>
    )}
              <option value="">Select Category</option>

            {categories
      .filter((category) => category.active)
      .map((category) => (
        <option key={category.id} value={category.id}>
          {category.name}
        </option>
      ))}
            </Input>
          </FormGroup>
        </Col>

        {/* Service Name */}
        <Col md="4">
          <FormGroup>
            <Label className="app-text-label">
              Service Name{' '}
              <small className="text-danger">*</small>
            </Label>

            <Input
      type="text"
      value={serviceForm.name}
      invalid={!!errors.name}
      onChange={(event) => {
        handleServiceChange('name', event.target.value);

        setErrors((previous) => ({
          ...previous,
          name: '',
        }));
      }}
      disabled={!serviceForm.categoryId}
      placeholder={
        serviceForm.categoryId
          ? 'Enter subcategory / service name'
          : 'Select Category first'
      }
    />

    {errors.name && (
      <div className="field-error">
        {errors.name}
      </div>
    )}
          </FormGroup>
        </Col>

        {/* Status */}
        <Col md="4">
        <FormGroup>
          <Label className="app-text-label">
            Status
          </Label>

          <Input
            type="select"
            value={serviceForm.active ? '1' : '0'}
            onChange={(event) =>
              handleServiceChange(
                'active',
                event.target.value === '1',
              )
            }
          >
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </Input>
        </FormGroup>
      </Col>
      </Row>

      <Row>
        {/* Salon Price */}
        <Col md="4">
          <FormGroup>
            <Label className="app-text-label">
              Salon Price (₹){' '}
              <small className="text-danger">*</small>
            </Label>

            <Input
      type="number"
      min="0"
      placeholder="Enter salon price"
      value={serviceForm.salonPrice}
      invalid={!!errors.salonPrice}
      onChange={(event) => {
        handleServiceChange(
          'salonPrice',
          event.target.value,
        );

        setErrors((previous) => ({
          ...previous,
          salonPrice: '',
        }));
      }}
    />

    {errors.salonPrice && (
      <div className="field-error">
        {errors.salonPrice}
      </div>
    )}
          </FormGroup>
        </Col>

        {/* Four Wheeler Price */}
        <Col md="4">
          <FormGroup>
            <Label className="app-text-label">
              Four Wheeler Price (₹){' '}
              <small className="text-danger">*</small>
            </Label>

            <Input
      type="number"
      min="0"
      placeholder="Enter four wheeler price"
      value={serviceForm.fourWheelPrice}
      invalid={!!errors.fourWheelPrice}
      onChange={(event) => {
        handleServiceChange(
          'fourWheelPrice',
          event.target.value,
        );

        setErrors((previous) => ({
          ...previous,
          fourWheelPrice: '',
        }));
      }}
    />

    {errors.fourWheelPrice && (
      <div className="field-error">
        {errors.fourWheelPrice}
      </div>
    )}
          </FormGroup>
        </Col>

    {/* Duration */}
        <Col md="4">
          <FormGroup>
            <Label className="app-text-label">
              Duration (Min){' '}
              <small className="text-danger">*</small>
            </Label>

            <Input
      type="number"
      min="0"
      placeholder="e.g. 60"
      value={serviceForm.duration}
      invalid={!!errors.duration}
      onChange={(event) => {
        handleServiceChange(
          'duration',
          event.target.value,
        );

        setErrors((previous) => ({
          ...previous,
          duration: '',
        }));
      }}
    />

    {errors.duration && (
      <div className="field-error">
        {errors.duration}
      </div>
    )}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        {/* Description */}
        <Col md="6">
          <FormGroup>
            <Label className="app-text-label">
              Description
            </Label>

            <Input
              type="textarea"
              rows="3"
              placeholder="Short description of the service"
              value={serviceForm.description}
              onChange={(event) =>
                handleServiceChange(
                  'description',
                  event.target.value,
                )
              }
            />
          </FormGroup>
        </Col>

        {/* Included Services */}
        <Col md="6">
          <FormGroup>
            <Label className="app-text-label">
              Included Services
            </Label>

            <TagsInput
              className="area-management-tags"
              value={serviceForm.includedServices}
              onChange={(tags) =>
                handleServiceChange(
                  'includedServices',
                  tags,
                )
              }
              addKeys={[9, 13, 188, ',']}
              addOnBlur
              addOnPaste
              pasteSplit={parseIncludedServices}
              onlyUnique
              tagProps={{
                className:
                  'react-tagsinput-tag bg-info text-white rounded',
                // Replacing tagProps drops the library default, which gives
                // the × its pointer cursor.
                classNameRemove: 'react-tagsinput-remove',
              }}
              inputProps={{
                className:
                  'react-tagsinput-input area-management-input',
                placeholder:
                  'Type a service',
              }}
            />

            <small className="text-muted">
              Type and press enter to add
              more services.
            </small>
          </FormGroup>
        </Col>
      </Row>

<Row className="mt-1">
  {/* Service Image */}
  <Col md="4">
    <FormGroup className="mb-0">
      <Label className="app-text-label">
        Service Image
      </Label>

<Input
  type="file"
  accept="image/*"
  ref={serviceImageInputRef}
  onChange={(event) => {
    const file = event.target.files[0] || null;

    if (file && file.size > MAX_IMAGE_SIZE) {
      setServiceImage(null);
      event.target.value = '';

      toast.error(
        'Maximum image size allowed is 500 KB.',
      );

      return;
    }

    setServiceImage(file);
  }}
/>

      {serviceImage && (
        <small className="text-muted d-block mt-1">
          Selected: {serviceImage.name}
        </small>
      )}
    </FormGroup>
  </Col>

  {/* Save + Reset */}
  <Col md="4">
    {/* Empty label keeps buttons aligned with file input */}
    <Label
      className="app-text-label"
      style={{ visibility: 'hidden' }}
    >
      Service Image
    </Label>

    <div className="d-flex gap-2">
      <AppButton
        variant="primary"
        onClick={saveService}
      >
        {editingService
          ? 'Update Service'
          : 'Save Service'}
      </AppButton>

      <AppButton
        variant="primary"
        outline
        type="button"
        onClick={resetServiceForm}
      >
        Reset
      </AppButton>
    </div>
  </Col>

  {/* Empty third column */}
  <Col md="4" />
</Row>
</ComponentCard>
            <ComponentCard
  title={
    <span>
      Existing Services 
     
    </span>
  }
>
  <DataTable
    columns={serviceColumns}
    data={serviceTableData}
    mode="client"
    pageSize={10}
    searchable
    searchPlaceholder="Search category or service..."
    emptyMessage="No subcategories / services found."
    rowKey={(row) => row.id}
  />
    </ComponentCard>
          </ComponentCard>
        </Col>
      </Row>
      </div>

      {/* ADD MAIN CATEGORY MODAL */}
      <Modal
        className="category-management-modal"
        isOpen={categoryModal}
        toggle={() => setCategoryModal(false)}
      >
        <ModalHeader toggle={() => setCategoryModal(false)}>
          Add Category
        </ModalHeader>

       <ModalBody>
  {/* Main Category Name */}
  <FormGroup>
    <Label>
       Category Name{' '}
      <small className="text-danger">*</small>
    </Label>

    <Input
      placeholder="Enter category name"
      value={categoryForm.name}
      invalid={!!errors.categoryName}
      onChange={(event) => {
        setCategoryForm({
          ...categoryForm,
          name: event.target.value,
        });

        setErrors((previous) => ({
          ...previous,
          categoryName: '',
        }));
      }}
    />

    {errors.categoryName && (
      <div className="field-error">
        {errors.categoryName}
      </div>
    )}
  </FormGroup>

  {/* Status + Image */}
  <Row>
    {/* Status */}
    <Col md="4">
      <FormGroup>
        <Label>
          Status
        </Label>

        <Input
          type="select"
          value={categoryForm.active ? '1' : '0'}
          onChange={(event) =>
            setCategoryForm({
              ...categoryForm,
              active: event.target.value === '1',
            })
          }
        >
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </Input>
      </FormGroup>
    </Col>

    {/* Category Image */}
    <Col md="8">
      <FormGroup>
        <Label>
          Category Image
        </Label>

      <Input
  type="file"
  accept="image/*"
  onChange={(event) => {
    const file = event.target.files[0] || null;

    if (file && file.size > MAX_IMAGE_SIZE) {
      setCategoryImage(null);
      event.target.value = '';

      toast.error(
        'Maximum image size allowed is 500 KB.',
      );

      return;
    }

    setCategoryImage(file);
  }}
/>

        {categoryImage && (
          <small className="text-muted d-block mt-1">
            Selected: {categoryImage.name}
          </small>
        )}
      </FormGroup>
    </Col>
  </Row>
</ModalBody>
        <ModalFooter>
          <AppButton
            variant="primary"
            outline
            type="button"
            onClick={() => {
              setCategoryModal(false);
              setValidation('');
            }}
          >
            Cancel
          </AppButton>

          <AppButton variant="primary" type="button" onClick={saveCategory}>
            Save Category
          </AppButton>
        </ModalFooter>
      </Modal>
      {/* MANAGE MAIN CATEGORIES MODAL */}

<Modal
  className="category-management-modal"
  isOpen={manageCategoryModal}
  toggle={() => {
    setManageCategoryModal(false);
    handleCancelEditCategory();
  }}
  size="lg"
>
  <ModalHeader
    toggle={() => {
      setManageCategoryModal(false);
      handleCancelEditCategory();
    }}
  >
    Update Category
  </ModalHeader>

  <ModalBody>
 <div
  id="update-main-category-form"
  className="mb-4"
>
  <Row>
    {/* Main Category Name */}
    <Col md="6">
      <FormGroup>
        <Label className="app-text-label">
           Category Name{' '}
          <small className="text-danger">*</small>
        </Label>

      <Input
  type="text"
  value={editCategoryName}
 className={editingCategory ? 'edit-highlight' : ''}
          invalid={!!errors.editCategoryName}
          onChange={(event) => {
            setEditCategoryName(event.target.value);

            setErrors((previous) => ({
              ...previous,
              editCategoryName: '',
            }));
          }}
          placeholder="Select a category to edit"
          disabled={!editingCategory}
        />

        {errors.editCategoryName && (
          <div className="field-error">
            {errors.editCategoryName}
          </div>
        )}
      </FormGroup>
    </Col>

    {/* Status */}
    <Col md="3">
      <FormGroup>
        <Label className="app-text-label">
          Status
        </Label>

        <Input
          type="select"
          value={editCategoryActive ? '1' : '0'}
          onChange={(event) =>
            setEditCategoryActive(
              event.target.value === '1',
            )
          }
          disabled={!editingCategory}
        >
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </Input>
      </FormGroup>
    </Col>

    {/* Empty third column */}
    <Col md="3" />
  </Row>

  {/* Row 2 */}
  {/* Row 2 */}
<Row>
  {/* Category Image */}
  <Col md="6">
    <FormGroup className="mb-0">
      <Label className="app-text-label">
        Category Image
      </Label>

     <Input
  type="file"
  accept="image/*"
  disabled={!editingCategory}
  onChange={(event) => {
    const file = event.target.files[0] || null;

    if (file && file.size > MAX_IMAGE_SIZE) {
      setEditCategoryImage(null);
      event.target.value = '';

      toast.error(
        'Maximum image size allowed is 500 KB.',
      );

      return;
    }

    setEditCategoryImage(file);
  }}
/>
      {editCategoryImage && (
        <small className="text-muted d-block mt-1">
          Selected: {editCategoryImage.name}
        </small>
      )}
    </FormGroup>
  </Col>

  {/* Update + Cancel */}
  <Col md="6">
    <div
      className="d-flex align-items-center gap-2"
      style={{ marginTop: '30px' }}
    >
      <AppButton
        label="Update Category"
        variant="primary"
        type="button"
        onClick={handleUpdateCategory}
        disabled={!editingCategory}
      />

      <AppButton
        label="Cancel"
        variant="primary"
        outline
        type="button"
        onClick={handleCancelEditCategory}
      />
    </div>
  </Col>
</Row>
</div>

    {/* MAIN CATEGORIES */}
  <div className="main-category-management-table">
  

 <DataTable
  columns={categoryColumns}
  data={allCategories}
  mode="client"
  pageSize={10}
  searchable={false}
  emptyMessage="No main categories found."
  rowKey={(row) => row.id}
/>
</div>
  </ModalBody>
</Modal>
<ImagePreviewModal
  isOpen={!!previewImage}
  toggle={() => setPreviewImage('')}
  imageUrl={previewImage}
/>
    </>
  );
}
